<template lang='pug' src='./navigation-mobile.pug'></template>

<script>
export default {
  data () {
    return {
      drawerActive: false,
      linksActive: false
    }
  },
  computed: {
    props () {
      return this.$store.state.app.nav
    },
    links () {
      return this.$router.options.routes
    }
  },
  methods: {
    openNav () {
      this.drawerActive ? document.body.classList.remove('body-stop') : document.body.classList.add('body-stop')
      if (!this.linksActive) {
        this.drawerActive = true
        setTimeout(() => {
          this.linksActive = true
        }, 200)
      } else {
        this.linksActive = false
        setTimeout(() => {
          this.drawerActive = false
        }, 450)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// navigation-mobile.vue?5183c6e6